import {
  TRIGGER_CONFIG_APP_PASSWORD_MODAL,
  TRIGGER_FEEDBACK_MODAL,
} from "../../constants/action.constants";

//Action to change current showFeedbackModal value in the reducer.
export const triggerFeedbackModal = () => {
  return { type: TRIGGER_FEEDBACK_MODAL };
};

//Action to change current showConfigAppPasswordModal value in the reducer.
export const triggerConfigAppPasswordModal = () => {
  return { type: TRIGGER_CONFIG_APP_PASSWORD_MODAL };
};
